class ArticleTableOfContents {
  constructor() {
    this.tocContainer = document.getElementById('article-toc-list');
    this.articleContent =
      document.querySelector('.article__content') ||
      document.querySelector('.article__wrapper .rte') ||
      document.querySelector('.article__wrapper');
    this.headings = [];
    this.tocItems = [];

    if (!this.tocContainer || !this.articleContent) return;

    this.init();
  }

  init() {
    this.tocContainer.innerHTML = '';
    this.headings = [];
    this.tocItems = [];

    this.extractHeadings();
    this.addAnchorsToHeadings();
    this.generateTOC();
    this.setupScrollSpy();
  }

  extractHeadings() {
    const headingElements = this.articleContent.querySelectorAll('h1, h2, h3, h4');

    headingElements.forEach((heading, index) => {
      const level = parseInt(heading.tagName.charAt(1), 10);
      const text = heading.textContent.trim();
      const id = this.generateId(text, index);

      this.headings.push({
        element: heading,
        level,
        text,
        id,
      });
    });
  }

  generateId(text, index) {
    let id = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    if (!id) id = `heading-${index}`;

    let uniqueId = id;
    let counter = 1;
    while (document.getElementById(uniqueId)) {
      uniqueId = `${id}-${counter}`;
      counter++;
    }

    return uniqueId;
  }

  addAnchorsToHeadings() {
    this.headings.forEach(({ element, id }) => {
      element.id = id;
    });
  }

  generateTOC() {
    if (this.headings.length === 0) {
      return;
    }

    this.headings.forEach(({ level, text, id }) => {
      const listItem = document.createElement('li');
      listItem.className = `article-toc__item article-toc__item--h${level}`;

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.className = 'article-toc__link';
      link.textContent = text;
      link.setAttribute('data-heading-id', id);

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetElement = document.getElementById(id);
        if (!targetElement) return;

        const cs = getComputedStyle(targetElement);
        const fromCss = parseFloat(cs.scrollMarginTop) || 0;
        const headerPx =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height')
          ) || 0;
        const extraAbove = 12;
        const minClearance = headerPx + 20;
        const margin = Math.max(fromCss, minClearance) + extraAbove;

        const top =
          window.scrollY + targetElement.getBoundingClientRect().top - margin;

        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth',
        });
        this.updateActiveLink(link);
      });

      listItem.appendChild(link);
      this.tocContainer.appendChild(listItem);
      this.tocItems.push({ link, element: document.getElementById(id) });
    });
  }

  updateActiveLink(activeLink) {
    this.tocItems.forEach(({ link }) => {
      link.classList.remove('active');
    });
    if (activeLink) activeLink.classList.add('active');
  }

  setupScrollSpy() {
    if (this.tocItems.length === 0) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      let currentHeading = null;

      for (let i = this.tocItems.length - 1; i >= 0; i--) {
        const { element, link } = this.tocItems[i];
        if (element && element.offsetTop <= scrollPosition) {
          currentHeading = link;
          break;
        }
      }

      this.updateActiveLink(currentHeading);
    };

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      },
      { passive: true }
    );

    handleScroll();
  }
}

const initArticleTOC = () => {
  new ArticleTableOfContents();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleTOC);
} else {
  initArticleTOC();
}

document.addEventListener('shopify:section:load', initArticleTOC);
